export default "__VITE_ASSET__D_OOGYhb__"